var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.error)?_c('app-error',{attrs:{"type":"loading","error":_vm.error}}):(_vm.loading)?_c('app-loader',{attrs:{"xs":_vm.xs,"sm":_vm.sm,"md":_vm.md,"lg":_vm.lg,"xl":_vm.xl}}):_c('div',[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }